import uiRouter from 'angular-ui-router';
import ServicesModule from '../services';
import { NextButtonModule } from './next-button';
import { GoogleMapModule } from './google-map';
import ScrollToErrorModule from './scroll-to-error/scroll-to-error';
import BindCompileModule from './bind-compile/bind-compile';
import ConfirmModule from './confirm/confirm';
import BrandingImageModule from './branding-image/branding-image';
import UiMaskAndroidOverrideModule from './ui-mask-android-override';
import EmailModule from './email/email';
import PasswordModule from './password/password';
import StepsIndicatorModule from './steps-indicator/steps-indicator';
import BsFormValidationModule from './bs-form-validation/bs-form-validation';
import DisableElementModule from './disable-element/disable-element';
import CharacterLimitModule from './character-limit/character-limit';
import MetaModule from './u-meta/u-meta';
import { LoadingDotsModule } from './loading-dots';
import TitleBarModule from './title-bar/title-bar';
import StepBannerModule from './step-banner/step-banner';
import { BackToDashboardButtonComponent } from './back-to-dashboard-button';
import { StepPageModule } from './step-page';
import { NameSelectorModule } from './name-selector';
import { RelevantContentComponent } from './relevant-content';
import { UCloudinaryImageDirectives } from './cloudinary-image';
import { AlternateBrandsModule } from './alternate-brands';
import { SuffixSelectModule } from './suffix-select';

export const DirectivesModule = angular.module('app.directives', [
  uiRouter,
  ServicesModule.name,
  GoogleMapModule.name,
  ScrollToErrorModule.name,
  BindCompileModule.name,
  ConfirmModule.name,
  BrandingImageModule.name,
  UiMaskAndroidOverrideModule.name,
  NextButtonModule.name,
  EmailModule.name,
  PasswordModule.name,
  StepsIndicatorModule.name,
  BsFormValidationModule.name,
  DisableElementModule.name,
  CharacterLimitModule.name,
  MetaModule.name,
  LoadingDotsModule.name,
  TitleBarModule.name,
  StepBannerModule.name,
  UCloudinaryImageDirectives.name,
]);

export {
  AlternateBrandsModule,
  BackToDashboardButtonComponent,
  UCloudinaryImageDirectives,
  ConfirmModule,
  GoogleMapModule,
  LoadingDotsModule,
  NameSelectorModule,
  NextButtonModule,
  RelevantContentComponent,
  StepPageModule,
  SuffixSelectModule,
};
